import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';
import { UploadDocumentServiceInterface } from '../interfaces/services/upload-document.service.interface';
import { UploadDocumentInput, UploadDocumentOutput } from '../dtos/representative.dto';

@Injectable()
export class UploadDocumentService implements UploadDocumentServiceInterface {
  private readonly _representativeRepository = inject(
    Types.RepresentativeRepository
  );

  async handle(input: UploadDocumentInput): Promise<UploadDocumentOutput> {
    return this._representativeRepository.uploadDocument(input);
  }
}
